import { Metamodel, Attribute } from '../base/model';
import { Activity } from './activity';
import { Notebook } from '../notebook/notebook';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { ParameterConfig } from './parameter-config';
import { ParameterConfigUtils } from '../adapters/linkedservices/parameter-config.util';
import { IAttribute, Collection } from '../base/annotation';
import { BigDataPool, NodeSize } from '../bigdatapool/bigdatapool';
import { format } from '../../shared/utils/string.util';
import { AzureSynapseArtifactsLinkedService } from '../linkedservice/azure-synapse-artifacts.linkedservice';
import { ParameterValue } from '../base/parameter-value';
import { A365BackendModel } from '../a365.backendmodel';
import { SparkConfiguration } from '../sparkconfiguration/sparkconfiguration';
import { Owned } from '../base/named';
import { SynapseActivityAuthenticationType } from './synapse-activity-authentication-type';

@Metamodel.model({
    name: ModelConstants.synapseNotebookActivity,
    referable: true
})
export class SynapseNotebookActivity extends Activity {
    public static readonly NAME: IAttribute;
    public static readonly SPARKPOOL: IAttribute;
    public static readonly EXECUTOR_SIZE: IAttribute;
    public static readonly DYNAMIC_EXECUTOR: IAttribute;
    public static readonly MIN_EXECUTORS: IAttribute;
    public static readonly MAX_EXECUTORS: IAttribute;
    public static readonly DRIVER_SIZE: IAttribute;
    public static readonly TARGET_SPARK_CONFIGURATION: IAttribute;
    public static readonly LINKED_SERVICE: Attribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.NotebookActivityLabel,
        constraint: {
            required: true
        },
        reference: true,
        templatable: true,
        association: 'NAME',
        accepts: ['String']
    })
    public notebook: Notebook;

    @Metamodel.attribute({
        display: shellStringResources.NotebookActivitySparkPoolLabel,
        reference: true,
        templatable: true,
        type: BigDataPool.MODEL,
        association: 'SPARKPOOL',
        accepts: ['String']
    })
    public sparkPool: BigDataPool;

    @Metamodel.attribute({
        display: shellStringResources.NotebookParametersLabel,
        constraint: {
            validator: ParameterConfigUtils.createParameterConfigurationValidator(true, null, false)
        }
    })
    public parameters?: ParameterConfig[] = [];

    public snapshot?: boolean = true;

    @Metamodel.attribute({
        display: shellStringResources.SparkJobDefinitionActivityExecutorSizeLabel,
        templatable: true,
        association: 'EXECUTOR_SIZE'
    })
    public executorSize?: NodeSize;

    @Metamodel.attribute({
        display: shellStringResources.SparkJobDefinitionActivityDynamicExecutorLabel,
        templatable: true,
        association: 'DYNAMIC_EXECUTOR'
    })
    public dynamicExecutor?: boolean;

    @Metamodel.attribute({
        display: shellStringResources.SparkJobDefinitionActivityMinExecutorsLabel,
        templatable: true,
        association: 'MIN_EXECUTORS'
    })
    public minExecutors?: number;

    @Metamodel.attribute({
        display: shellStringResources.SparkJobDefinitionActivityMaxExecutorsLabel,
        templatable: true,
        association: 'MAX_EXECUTORS'
    })
    public maxExecutors?: number;

    @Metamodel.attribute({
        display: shellStringResources.SparkJobDefinitionActivityDriverSizeLabel,
        templatable: true,
        association: 'DRIVER_SIZE'
    })
    public driverSize?: NodeSize;

    @Metamodel.attribute({
        type: SynapseActivityAuthenticationType.MODEL
    })
    public authentication: SynapseActivityAuthenticationType = Owned.create<SynapseActivityAuthenticationType>(SynapseActivityAuthenticationType.MODEL, this);

    @Metamodel.attribute({
        display: shellStringResources.ApacheSparkConfiguration,
    })
    public configurationType?: A365BackendModel.ConfigurationType;

    @Metamodel.attribute({
        display: shellStringResources.ApacheSparkConfiguration,
        templatable: true,
        association: 'TARGET_SPARK_CONFIGURATION',
        accepts: ['String']
    })
    public targetSparkConfiguration?: SparkConfiguration;

    @Metamodel.attribute({
        display: shellStringResources.ApacheSparkConfiguration,
        constraint: {
            validator: ParameterConfigUtils.createParameterConfigurationValidator()
        }
    })
    public sparkConfig?: ParameterConfig[];

    @Metamodel.attribute({
        display: format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AzureSynapseAnalytics),
        reference: true,
        association: 'LINKED_SERVICE',
        type: AzureSynapseArtifactsLinkedService.MODEL
    })
    public linkedService?: AzureSynapseArtifactsLinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters: ParameterValue[] = [];
}
